import { Injectable } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { DashboardRepository } from 'src/app/core/data/repository';
import {
  Bloc,
  ErrorState,
  ReadyState,
  ShowPopUpLoadingState,
  ShowSuccessMessageState,
} from 'src/app/shared/bloc/base-bloc';
import { NonDrawing } from 'src/app/shared/model';

import { ContactUsPopupEvent, ContactUsPopUpInitEvent, ContactUsPopUpSendReplyEvent } from './contact-us-popup-event';
import { ContactUsPopupState, ContactUsSendedReplyState } from './contact-us-popup-state';
import { MediaRepository } from '../../../../../core/data/repository/media-repository';
import { concatMap } from 'rxjs/operators';
import { FileType, Mimetype } from 'src/app/core/common';

@Injectable()
export class ContactUsPopUpBloc extends Bloc<ContactUsPopupEvent, ContactUsPopupState> {
  constructor(private dashboardRepository: DashboardRepository, private mediaRepository: MediaRepository) {
    super();
  }
  onIncomingEvents(event: ContactUsPopupEvent): void {
    if (event instanceof ContactUsPopUpInitEvent) {
      // loading component
      this.onState$.next(new ShowPopUpLoadingState());
      // call api
      event
        .caller()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new ReadyState(result));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    }
    if (event instanceof ContactUsPopUpSendReplyEvent) {
      // loading component
      this.onState$.next(new ShowPopUpLoadingState());
      // call api
      let stream$;
      if (event.replyForm.file.length > 0) {
        stream$ = this.mediaRepository.getUploadImageSignedURL(event.replyForm.file[0]).pipe(
          concatMap((fileURL) => {
            let fileType;
            if (event.replyForm.file[0].type.match(/image\/*/)) {
              fileType = FileType.IMAGE;
            }
            if (event.replyForm.file[0].type.match(/video\/*/)) {
              fileType = FileType.VIDEO;
            }

            event.replyForm = { ...event.replyForm, fileURL: fileURL, fileType: fileType };
            return this.dashboardRepository.contactUsMessageReply(event.replyForm);
          })
        );
      } else {
        event.replyForm = { ...event.replyForm };
        stream$ = this.dashboardRepository.contactUsMessageReply(event.replyForm);
      }

      stream$.pipe(takeUntil(this.destroy$)).subscribe({
        next: (result) => {
          this.onState$.next(new ShowSuccessMessageState(new ContactUsSendedReplyState(result), 'REPLY_SENDED'));
        },
        error: (error) => {
          this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
        },
      });
    }
  }
}
